<template>
    <!--
        NOTA: Solo se actualizaron los switches a ToggleSwitch (nuevo admin UI).
        El resto de la tab (QuillEditor, Dropzone, imágenes) mantiene el estilo
        anterior a propósito. El rediseño completo de TODAS las tabs de
        configuración se hará más adelante en una tarea aparte, para mantener
        consistencia visual entre tabs (opciones, imágenes, abonos, etc.).
    -->
    <div class="card-body">
        <div class="form">
            <div class="col-12 mb-4">
                <ToggleSwitch
                    :value="Boolean(managerLocal.renovar_abono_solo_con_dni)"
                    id="renovar_abono_solo_con_dni"
                    @input="managerLocal.renovar_abono_solo_con_dni = $event ? 1 : 0"
                >
                    Permitir renovaciones online solo con DNI/NIF
                </ToggleSwitch>
            </div>
            <div class="col-12 mb-4">
                <ToggleSwitch
                    :value="Boolean(managerLocal.comprobar_dni)"
                    id="comprobar_dni"
                    @input="managerLocal.comprobar_dni = $event ? 1 : 0"
                >
                    Comprobar DNI para hacer nuevo abono
                </ToggleSwitch>
            </div>
            <div class="col-12 mb-4">
                <ToggleSwitch
                    :value="Boolean(managerLocal.comprobacion_butacas_abonos)"
                    id="comprobacion_butacas_abonos"
                    @input="managerLocal.comprobacion_butacas_abonos = $event ? 1 : 0"
                >
                    Activar comprobación de butacas
                </ToggleSwitch>
            </div>
            <div class="col-12 mb-4">
                <ToggleSwitch
                    :value="Boolean(managerLocal.activar_limite_puntos)"
                    id="activar_limite_puntos"
                    @input="onLimitePuntosToggle($event)"
                >
                    Limitar porcentaje de puntos del monedero
                </ToggleSwitch>
            </div>
            <div class="col-12 mb-4" v-if="managerLocal.activar_limite_puntos">
                <BaseInputNumber
                    v-model="managerLocal.porcentaje_limite_puntos"
                    label="Porcentaje máximo de puntos a usar (0-100)"
                    :min="0"
                    :max="100"
                    :step="1"
                    custom-class="tw:w-1/2"
                />
                <p class="tw:text-sm tw:text-gray-500 tw:mt-1">
                    <i class="fas fa-info-circle tw:text-blue-400 tw:mr-1"></i>
                    Porcentaje máximo del saldo de puntos que el cliente podrá canjear en cada compra.
                    Ej: Con un <strong>30%</strong>, un cliente con <strong>100 puntos</strong> podrá usar hasta <strong>30 puntos</strong>.
                </p>
            </div>
            <div class="col-12 mb-3">
                <label class="form-label" for="informacion">Texto para las condiciones de la compra de abonos mediante plazos:</label>
                <QuillEditor v-model="managerLocal.condiciones_abonos_plazos"/>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen cabecera pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X287 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen.
                    </small>
                </p>
                <template v-if="managerLocal.imagen_abono_cabecera_url">
                    <img :src="managerLocal.imagen_abono_cabecera_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_abono_cabecera')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone
                        v-if="url"
                        :url="url"
                        :height="287"
                        :width="2182"
                        @success="imagenSubida('imagen_abono_cabecera', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen publicidad pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X667 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen.
                    </small>
                </p>
                <template v-if="managerLocal.imagen_abono_publicidad_url">
                    <img :src="managerLocal.imagen_abono_publicidad_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_abono_publicidad')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone
                        v-if="url"
                        :url="url"
                        :height="667"
                        :width="2182"
                        @success="imagenSubida('imagen_abono_publicidad', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen patrocinadores pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X319 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen.
                    </small>
                </p>
                <template v-if="managerLocal.imagen_abono_patrocinadores_url">
                    <img :src="managerLocal.imagen_abono_patrocinadores_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_abono_patrocinadores')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone
                        v-if="url"
                        :url="url"
                        :height="319"
                        :width="2182"
                        @success="imagenSubida('imagen_abono_patrocinadores', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <Button data-cy="guardar-configuracion" @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import QuillEditor from "@/modules/ui/QuillEditor.vue";
    import Dropzone from '@/components/common/Dropzone';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue';

    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                conf: {},
                managerLocal: { ...this.manager }
            }
        },
        methods: {
            onLimitePuntosToggle(value) {
                this.managerLocal.activar_limite_puntos = value ? 1 : 0;
                if (!value) {
                    this.managerLocal.porcentaje_limite_puntos = 100;
                }
            },
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'imagen_abono_patrocinadores':
                        this.managerLocal.imagen_abono_patrocinadores = null;
                        this.managerLocal.imagen_abono_patrocinadores_url = null;
                        break;
                    case 'imagen_abono_cabecera':
                        this.managerLocal.imagen_abono_cabecera = null;
                        this.managerLocal.imagen_abono_cabecera_url = null;
                        break;
                    case 'imagen_abono_publicidad':
                        this.managerLocal.imagen_abono_publicidad = null;
                        this.managerLocal.imagen_abono_publicidad_url = null;
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_abono_patrocinadores':
                        this.managerLocal.imagen_abono_patrocinadores = response;
                        break;
                    case 'imagen_abono_cabecera':
                        this.managerLocal.imagen_abono_cabecera = response;
                        break;
                    case 'imagen_abono_publicidad':
                        this.managerLocal.imagen_abono_publicidad = response;
                        break;
                }
            }
        },
        components: {
            Dropzone, QuillEditor, ToggleSwitch, BaseInputNumber
        }
    }
</script>
